import { gql } from '@apollo/client';

// input CancelSubscriptionInput {
// 	 purchaseId: ID!
// }

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription($data: CancelSubscriptionInput!) {
    cancelSubscription(data: $data) {
      id
      stripeId
      subscriptionStatus
      subscriptionCancelledAt
    }
  }
`;
